import { useRouter } from "next/navigation";

import { useIsTwistCustomer } from "lib/customer/twist/utils";
import DataFactory404Page from "pages/404";

export default function LibraryDesignsPage() {
  const { isTwist } = useIsTwistCustomer();
  const router = useRouter();

  if (!isTwist) {
    // Only Twist is allowed to see /library-designs
    return <DataFactory404Page />;
  }

  router.push("/projects/");
}
